export enum GidStatus {
	"IDEA" = "IDEA",
	"IN_PROGRESS" = "IN_PROGRESS",
	"WAITING_FOR_DEVELOPMENT" = "WAITING_FOR_DEVELOPMENT",
	"DEAD" = "DEAD",
	"DONE" = "DONE",
}
